<template>
    <div class="version1-right">
        <div class="version1-right-div">
          <Top></Top>
          <Middle></Middle>
          <Bottom></Bottom>
        </div>
    </div>
</template>

<script>
import Top from './top'
import Bottom from './bottom'
import Middle from './middle'
export default {
  data() {
    return {

    }
  },
  components: {
    Top,
    Bottom,
    Middle
  }
}
</script>
